export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/outEastIcon-401351b1153d17bb89646a23233ce5e1.svg";